import React, { useRef, useEffect } from "react";
import _ from "lodash";
import cx from "classnames";
import { connect } from "react-redux";

import Start from "./screens/Start";
import Showcase from "./screens/Showcase";
import Voting from "./screens/Voting";
import Over from "./screens/Over";
import * as sbsAction from "redux/sbs/action";

const CC = (props) => {
  const set_cc_countdown = _.get(props, "set_cc_countdown");
  const set_caption = _.get(props, "set_caption");
  const set_cc_vote = _.get(props, "set_cc_vote");
  const gameReducer = _.get(props, "gameReducer");
  const sbsReducer = _.get(props, "sbsReducer");
  const cc_countdown = _.get(sbsReducer, "cc_countdown");
  const caption = _.get(sbsReducer, "caption");
  const cc_vote = _.get(sbsReducer, "cc_vote");
  const currentUser = _.get(gameReducer, "currentUser");
  const mobile_app = _.get(gameReducer, "mobile_app");
  const roomObj = _.get(gameReducer, "roomObj");
  const roomId = _.get(roomObj, "id");
  const users = _.get(roomObj, "users");
  const game_state = _.get(roomObj, "game_state");
  const captions = _.get(game_state, "captions");
  const deadline_time = _.get(game_state, "deadline_time");
  const player = _.get(game_state, "player");
  const photo = _.get(game_state, "photo");
  const status = _.get(game_state, "status");
  const current_round = _.get(game_state, "current_round");

  const start_params = _.get(props, "paramsReducer.gameObj.1_start");
  const showcase_params = _.get(props, "paramsReducer.gameObj.2_showcase");
  const voting_params = _.get(props, "paramsReducer.gameObj.3_voting");
  const over_params = _.get(props, "paramsReducer.gameObj.4_over");

  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser?.userId
  );
  const userCaption = captions?.find(
    (item) => item.player_id === currentPlayer?.player_id
  );
  const playerObj = player?.find(
    (player) => player.player_id === currentPlayer?.player_id
  );
  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    set_caption("");
    set_cc_vote(null);
  }, [current_round]);

  useEffect(() => {
    if (status === "Voting") {
      if (mobile_app) {
        const message = {
          action: "vibrate"
        };
        window.parent.postMessage(message, "*");
      } else {
        const canVibrate = window.navigator.vibrate;
        if (canVibrate) window.navigator.vibrate(500);
      }
    }
  }, [status]);

  return (
    <div className="smallbites heightFull">
      <div
        className={cx("bingo-content-wrapper", {
          "playing-overflow-scroll": status === "Playing"
        })}
      >
        <div className="say-what-parent text-center">
          {status === "Start" && (
            <Start
              users={users}
              mobile_app={mobile_app}
              start_params={start_params}
            />
          )}
          {status === "Showcase" && (
            <Showcase
              photo={photo}
              roomId={roomId}
              caption={caption}
              mobile_app={mobile_app}
              set_caption={set_caption}
              userCaption={userCaption}
              cc_countdown={cc_countdown}
              currentPlayer={currentPlayer}
              deadline_time={deadline_time}
              showcase_params={showcase_params}
              set_cc_countdown={set_cc_countdown}
            />
          )}
          {status === "Voting" && (
            <Voting
              users={users}
              photo={photo}
              roomId={roomId}
              cc_vote={cc_vote}
              captions={captions}
              playerObj={playerObj}
              mobile_app={mobile_app}
              set_cc_vote={set_cc_vote}
              currentPlayer={currentPlayer}
              voting_params={voting_params}
            />
          )}
          {status === "Over" && (
            <Over
              users={users}
              photo={photo}
              player={player}
              captions={captions}
              over_params={over_params}
              currentPlayer={currentPlayer}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sbsReducer: state.sbsReducer,
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => ({
  set_cc_vote: (data) => dispatch(sbsAction.set_cc_vote(data)),
  set_caption: (data) => dispatch(sbsAction.set_caption(data)),
  set_cc_countdown: (data) => dispatch(sbsAction.set_cc_countdown(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(CC);
